@if (annonces$ | async; as annonces) {
  @if (annoncesFiltered.length > 0 && showAnnouncements((logementCourant$ | async))) {
    <div class="card shadow">
      <div class="card-header color-blue">Annonces partenaires</div>
      <div class="card-body">
        <swiper-container class="carousel-logos" [breakpoints]="carouselBreakpoints" navigation="true" loop="true" space-between="8">
          @for (annonce of annoncesFiltered; track annonce.id) {
            <swiper-slide>
              <div class="card shadow">
                <div class="card-body d-flex cursor-pointer p-0 align-items-center justify-content-center" [routerLink]="'/annonces/' + annonce.id">
                  <img [src]="annonce.logo.url | backResource" class="img-fluid logo">
                </div>
              </div>
            </swiper-slide>
          }
        </swiper-container>
      </div>
    </div>
  }
}
